export default "__VITE_ASSET__0de3101d__"